import { createSlice } from '@reduxjs/toolkit'
import { fetchStockHoldersEquity, fetchSesRawJournalData, fetchSesLibraries, fetchSesBeginningBalances, fetchSesStatement, fetchSesMMMSplitEntries } from './thunks/stockHoldersEquity';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    isNoteActive: false,
    // SES-WP (Workpaper) state
    sesJournalData: { periodOne: null, periodTwo: null },
    sesJournalLoading: false,
    sesLibrary: [],
    sesLibraryLoading: false,
    sesBeginningBalances: {},
    sesBeginningBalancesLoading: false,
    sesMMMSplitEntries: { periodOneData: [], periodTwoData: [] },
    // SES Statement (Phase 7 generated output) state
    sesStatementData: { periodOneData: null, periodTwoData: null },
    sesStatementLoading: false,
}

const stockHolderEquity = createSlice({
    name: 'STOCKHOLDEREQUITY',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setEsNoteActiveState(state, action){
          state.isNoteActive = !state.isNoteActive
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStockHoldersEquity.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchStockHoldersEquity.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchStockHoldersEquity.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
        builder.addCase(fetchSesRawJournalData.pending, (state) => {
          state.sesJournalLoading = true
        })
        builder.addCase(fetchSesRawJournalData.fulfilled, (state, action) => {
          state.sesJournalLoading = false
          state.sesJournalData = action.payload || { periodOne: null, periodTwo: null }
        })
        builder.addCase(fetchSesRawJournalData.rejected, (state, action) => {
          state.sesJournalLoading = false
          state.error = action.error.message
        })
        builder.addCase(fetchSesLibraries.pending, (state) => {
          state.sesLibraryLoading = true
        })
        builder.addCase(fetchSesLibraries.fulfilled, (state, action) => {
          state.sesLibraryLoading = false
          state.sesLibrary = action.payload || []
        })
        builder.addCase(fetchSesLibraries.rejected, (state, action) => {
          state.sesLibraryLoading = false
          state.error = action.error.message
        })
        builder.addCase(fetchSesBeginningBalances.pending, (state) => {
          state.sesBeginningBalancesLoading = true
        })
        builder.addCase(fetchSesBeginningBalances.fulfilled, (state, action) => {
          state.sesBeginningBalancesLoading = false
          state.sesBeginningBalances = action.payload || {}
        })
        builder.addCase(fetchSesBeginningBalances.rejected, (state, action) => {
          state.sesBeginningBalancesLoading = false
          state.error = action.error.message
        })
        builder.addCase(fetchSesMMMSplitEntries.fulfilled, (state, action) => {
          state.sesMMMSplitEntries = action.payload || { periodOneData: [], periodTwoData: [] }
        })
        builder.addCase(fetchSesStatement.pending, (state) => {
          state.sesStatementLoading = true
        })
        builder.addCase(fetchSesStatement.fulfilled, (state, action) => {
          state.sesStatementLoading = false
          state.sesStatementData = action.payload || { periodOneData: null, periodTwoData: null }
        })
        builder.addCase(fetchSesStatement.rejected, (state, action) => {
          state.sesStatementLoading = false
          state.error = action.error.message
        })
    }
});

export const { addSymbols, data, setEsNoteActiveState } = stockHolderEquity.actions

export default stockHolderEquity;